function tableFIlter(a) {
  var columns_and_cells = document.getElementsByClassName("filter_comp");
  var currentValue = a.value;

  for (let i = 0; i < columns_and_cells.length; i++) {
    if (
      columns_and_cells[i].getAttribute("data-filter") != currentValue &&
      currentValue != "all"
    ) {
      columns_and_cells[i].style.display = "none";
    } else {
      columns_and_cells[i].style.display = "flex";
    }
  }
}
